<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img
          src="@/assets/img/assguard logo_on_white.png"
          alt="logo"
        >
        <div class="md-body-1">
          Run the world
        </div>
      </div>

      <div
        v-if="isProd"
        class="oktaForm"
      >
        <p>To login into the Production instance, you'll need the <b>ClearVPN_admin</b> Okta app.</p>

        <md-button
          href="https://macpaw.okta.com/app/UserHome"
          class="md-primary"
          style="margin: 20px auto;"
        >
          Go Okta, go crazy
        </md-button>
      </div>

      <div
        v-else
        class="form"
      >
        <md-field>
          <label>E-mail</label>
          <md-input
            v-model="login.email"
            autofocus
          />
        </md-field>

        <md-field md-has-password>
          <label>Password</label>
          <md-input
            v-model="login.password"
            type="password"
          />
        </md-field>

        <div class="actions md-layout md-alignment-center">
          <md-button
            class="md-raised md-primary"
            @click="auth"
          >
            Log in
          </md-button>
        </div>
      </div>

      <div
        v-if="loading"
        class="loading-overlay"
      >
        <md-progress-spinner
          md-mode="indeterminate"
          :md-stroke="2"
        />
      </div>
    </md-content>
  </div>
</template>

<script>
    import { CAPTCHA_KEY, getCaptchaToken } from "../../utils/captchaHelper";
    import { isProd } from "../../utils/envDetector";
    import { UNKNOWN_ROLE, saveUserRole } from "../../assets/adminRoles";

    export default {
        name: "App",
        data() {
            return {
                isProd: isProd(),

                imgLogo: {
                    type: String,
                    default: require("@/assets/img/assguard logo_on_white.png")
                },
                loading: false,
                login: {
                    email: "",
                    password: ""
                }
            };
        },
        mounted() {
          if (!this.isProd) {
            const reCaptchaScript = document.createElement("script");
            reCaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${CAPTCHA_KEY}`;
            document.head.append(reCaptchaScript);
          }


          const params = new URLSearchParams(window.location.search);
          const accessToken = params.get("access_token");
          const refreshToken = params.get("refresh_token");
          if (accessToken && refreshToken) {
            localStorage.setItem("jwt", accessToken);
            localStorage.setItem("refreshToken", refreshToken);

            this.loading = true;
            this.$http.get("/v1/admin/profile")
              .then(res => {
                saveUserRole(res.data["role"]);

                this.$emit("loggedIn");
                if (this.$route.params.nextUrl != null) {
                  this.$router.push(this.$route.params.nextUrl);
                } else {
                  this.$router.push("dashboard");
                }
              })
              .finally(() => this.loading = false);
          }
        },
        methods: {
            auth() {
                this.loading = true;

                getCaptchaToken()
                  .then(({ token, CAPTCHA_KEY }) => this.$http.post("/v1/admin/account/sign-in", {
                    email: this.login.email,
                    password: this.login.password,
                    user_id: "01FF4RSMQ5D6M4965RTCZ8Z5SA",
                    recaptcha_token: token,
                    recaptcha_site_key: CAPTCHA_KEY
                  }))
                  .then(
                    response => {
                        this.loading = false;

                        console.log(response.data);

                        if (response.data["access_token"]) {
                            localStorage.setItem("jwt", response.data["access_token"]);
                            localStorage.setItem("refreshToken", response.data["refresh_token"]);

                            saveUserRole(UNKNOWN_ROLE);
                            this.$emit("loggedIn");
                            if (this.$route.params.nextUrl != null) {
                              this.$router.push(this.$route.params.nextUrl);
                            } else {
                              this.$router.push("dashboard");
                            }
                        }
                    },
                    err => {
                        console.error(err);

                        this.loading = false;
                    });
            }
        }
    };
</script>

<style lang="scss">
    .centered-container {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        height: 100vh;

        .title {
            text-align: center;
            margin-bottom: 30px;

            img {
                margin-bottom: 6px;
            }
        }
    
        .actions {
          .md-button {
              margin: 0;
          }
        }

        .form {
            margin-bottom: 60px;
        }

        .background {
            /*background: url();*/
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            bottom: 0;
            right: 0;
            left: 0;
            z-index: 0;
        }

        .md-content {
            z-index: 1;
            padding: 40px;
            width: 100%;
            max-width: 400px;
            position: relative;
        }

        .loading-overlay {
            z-index: 10;
            top: 0;
            left: 0;
            right: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            justify-content: center;
        }
      }

      .oktaForm {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
</style>
